<template>
  <div class="dialog-modal" role="alert">
    <div class="dialog-modal__wrapper">
      <button @click="$emit('close-dialog-modal')" class="dialog-modal__close">
        <span class="dialog-modal__close--icon material-icons">clear</span>
      </button>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogModal',
  methods: {
    closeModal() {
      this.$emit('closeDialogModal')
    },
  },
  created() {
    const body = document.querySelector('body')
    body.classList.add('modal-open')
  },
  destroyed() {
    const body = document.querySelector('body')
    body.classList.remove('modal-open')
  },
}
</script>
<style lang="scss" scoped>
.dialog-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  transition: opacity 0.3s ease;
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    top: 20%;
    margin: 0px auto;
    background-color: var(--light-gray);
    color: var(--white);
    max-width: 400px;
    min-height: 200px;
    font-size: 16px;
    padding-top: 10px;
  }
  &__close {
    width: 50px;
    height: 50px;
    position: absolute;
    right: -20px;
    top: -50px;
    background: none;
    border: none;
    cursor: pointer;
    color: white;
    &:hover {
      .single-video__close--icon {
        fill: var(--orange);
      }
    }
    &--icon {
      fill: var(--white);
    }
  }
  &__spinner-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .action-buttons {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    width: 100%;
    button {
      cursor: pointer;
      border-radius: 15px;
      padding: 5px 10px;
      font-size: 11px;
      color: white;
      border: 1px solid var(--orange);
      margin-top: 10px;
      background: transparent;
      width: 100px;
      height: 40px;
      margin-right: 10px;
      margin-left: 10px;
    }
  }
}
</style>
